import Vue from 'vue';
import Component from 'vue-class-component';

import BbModal from 'common/components/BbModal';
import BbForm from 'components/BbForm';
import BbField from 'components/BbField';
import SendGreetingEmailMutation from 'assets/graphql/mutations/SendGreetingEmailMutation.graphql';

@Component({
  components: {
    BbModal,
    BbForm,
    BbField,
  },
  props: {
    buyer: {
      type: Object,
      required: false,
    },
    user: {
      type: String,
      required: false,
    },
    buyerCorpo: {
      type: Boolean,
      required: false,
    },
  },
})
export default class ThanksModalComponent extends Vue {
  showFormModal = false;
  showSuccessMessage = false;
  form = {
    email: '',
    message: '',
    sender: this.user,
  };
  errors = {};

  get title() {
    return `Dale las gracias a ${this.buyer.name}!`;
  }

  get description() {
    if (this.buyerCorpo)
      return 'Enviale unas palabras de agradecimiento a quien te hizo este regalo, lo recibirá por e-mail y seguro le sacaras una sonrisa.';
    return 'Enviale unas palabras de agradecimiento a quien te hizo este regalo.';
  }

  toggleFormModal() {
    this.showFormModal = !this.showFormModal;
  }

  toggleSuccessMessage() {
    this.showSuccessMessage = true;
    this.showFormModal = false;
  }

  sendForm() {
    this.$apollo
      .mutate({
        mutation: SendGreetingEmailMutation,
        variables: {
          email: this.buyerCorpo ? this.buyer.email : this.form.email,
          message: this.form.message,
          sender: this.form.sender,
        },
      })
      .then(() => {
        this.toggleSuccessMessage();
      });
  }
}
